module.exports = __webpack_public_path__ + "static/musa-badge-gold-93d7166e345d43fcc18f4952b7a2b6a5.png";